import { Helmet } from "react-helmet-async"
import { useEffect, useState } from "react"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../../components/ui/carousel"
import { DoctorCard } from "../../components/doctor-card"

export default function Leadership() {
  const [doctors, setDoctors] = useState([])
  const ids = ["29", "31", "32", "33"]

  useEffect(() => {
    const url = `/wp-json/wp/v2/doctors?include=${ids.join(",")}&acf_format=standard&_embed&per_page=100&orderby=include`
    
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const sorted = ids
          .map((id) => data.find((d) => String(d.id) === String(id)))
          .filter(Boolean)
        setDoctors(sorted)
      })
      .catch((err) => {
        console.error("Error fetching doctors:", err)
        setDoctors([])
      })
  }, [])

  return (
    <>
      <Helmet>
        <title>Leadership - Pranaam Hospitals</title>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <div className="relative h-96 md:h-[500px] overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src="/images/ModernHospitalFacility.png" 
              alt="Modern Hospital Facility" 
              className="w-full h-full object-fill object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>
          </div>
          <div className="relative z-10 flex items-center justify-center h-full">
            <div className="text-center text-white px-4 max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-6xl font-bold mb-4">Meet Our Leaders</h1>
              <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto">
                Visionary healthcare professionals dedicated to excellence, innovation, and compassionate patient care
              </p>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
                Our leadership team brings together decades of experience in healthcare, management, and innovation to guide Pranaam Hospitals towards excellence.
              </p>
            </div>

            <Carousel className="w-full max-w-5xl mx-auto">
              <CarouselContent>
                {doctors.length > 0 ? (
                  doctors.map((doctor) => {
                    if (!doctor) return null
                    const name = doctor?.title?.rendered || "No name"
                    const specialty = doctor?.acf?.expertised_area || "Specialty not available"
                    const experience = doctor?.acf?.latest_achievement || doctor?.excerpt?.rendered || ""
                    const image =
                      doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                      doctor.featured_media_url ||
                      "/placeholder.svg?height=300&width=300&text=Doctor"

                    return (
                      <CarouselItem key={doctor.id} className="md:basis-1/2 lg:basis-1/3">
                        <DoctorCard
                          name={name}
                          specialty={specialty}
                          experience={experience}
                          image={image}
                          slug={doctor.slug}
                        />
                      </CarouselItem>
                    )
                  })
                ) : (
                  <p className="text-center w-full py-6">Loading doctors...</p>
                )}
              </CarouselContent>

              <div className="flex justify-center mt-8">
                <CarouselPrevious className="relative mr-2 left-0" />
                <CarouselNext className="relative ml-2 right-0" />
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </>
  )
}
